import styled from 'styled-components';
import { phoneFrameSizes } from '@components/PhoneFrame/PhoneFrame';
import { getFullHeightSectionHeight, largeLayout } from '@styles/layout';
import { multiplePixel } from '@styles/utils';
import bgImage = require('./background.jpg');
import illuCesar = require('./illus/cesar.svg');
import illuDarthvader = require('./illus/darthvader.svg');
import illuGameboy = require('./illus/gameboy.svg');
import illuIpod = require('./illus/ipod.svg');
import illuPalaischinois = require('./illus/palaischinois.svg');

const phoneWidth = largeLayout.getSize(4);
export const phoneScale = phoneWidth / phoneFrameSizes.width;

export const SectionOneBackground = styled.div`
  position: absolute;
  bottom: 0;
  left: 70%;
  height: ${props => getFullHeightSectionHeight(props.theme.windowHeight, props.theme.windowWidth)}px;
  width: 2000px;
  transform-origin: center left;
  transform: skewX(-20deg);
  overflow: hidden;
`;

export const SectionOneBackgroundImg = styled.div`
  position: absolute;
  bottom: 0;
  height: ${props => getFullHeightSectionHeight(props.theme.windowHeight, props.theme.windowWidth)}px;
  left: 0;
  width: 2000px;
  background-image: url(${bgImage});
  background-position: left center;
  background-size: auto 100%;
  transform-origin: bottom left;
  transform: skewX(20deg);
`;

export const SectionOnePhoneFrame = styled.div`
  position: absolute;
  left: 70%;
  top: 50%;
  transform: translate(-50%, -50%) scale(${phoneScale}) rotate(20deg);
`;

export const BaselineWraper = styled.div`
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
`;

export const BadgesWraper = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 15%;
  left: 0;

  & > div {
    margin-right: 1rem;
  }
`;

export const SectionOnePhoneBackground = styled.div`
  position: absolute;
  ${multiplePixel(-350, 'left', 'top', 'bottom')} right: 50%;
  overflow: hidden;
`;

export const IlluContainer = styled.div`
  background-size: 100% 100%;
  position: absolute;
  height: 20%;
  width: 60%;
  transotion-duration: 0.3s;
`;

export const IlluCesar = IlluContainer.extend`
  background: url('${illuCesar}');
  left: 10%;
  top: 40%;
  transform: rotate(260deg);
  &:hover {
    transform: translate(0deg);
  }
`;

export const IlluDarthvader = IlluContainer.extend`
  background: url('${illuDarthvader}');
  left: 12.5%;
  top: 20%;
  transform: rotate(310deg);
  &:hover {
    transform: translate(0deg);
  }
`;

export const IlluGameboy = IlluContainer.extend`
  background: url('${illuGameboy}');
  left: 12%;
  top: 60%;
  transform: rotate(-30deg);
  &:hover {
    transform: translate(0deg);
  }
`;

export const IlluIpod = IlluContainer.extend`
  background: url('${illuIpod}');
  left: 40%;
  top: 79%;
  transform: rotate(-30deg);
  &:hover {
    transform: translate(0deg);
  }
`;

export const IlluPalaischinois = IlluContainer.extend`
  background: url('${illuPalaischinois}');
  left: 42%;
  top: 4%;
  transform: rotate(330deg);
  &:hover {
    transform: translate(0deg);
  }
`;



// WEBPACK FOOTER //
// src/app/src/components/SectionOne/SectionOne.s.ts